module.exports = __webpack_public_path__ + "static/media/quote-left.f70d9584.svg";